import $ from 'jquery';
import Tips from './Tips';

/* ===============================================================
  AI Request System
=============================================================== */
class AiRequest {
    // Initialize
    constructor() {
        this.wrapperSelector = '.irantheme-ai-request';
        this.triggerSelector = '.irantheme-ai-request-trigger';
        this.submitSelector = '.irantheme-ai-request-submit';
        this.textSelector = '.irantheme-ai-request-text';
        this.panelSelector = '.irantheme-ai-request-panel';
        this.preloaderSelector = '.irantheme-ai-request-preloader';
        this.responseSelector = '.irantheme-ai-request-response';

        this.tip = new Tips();
        this.init();
    }

    async init() {
        this.events();
    }

    // Events
    events() {
        $(document).on('click', this.triggerSelector, (e) =>
            this.togglePanel(e),
        );
        $(document).on('click', this.submitSelector, (e) =>
            this.submitDispatcher(e),
        );
    }

    // Toggle the form panel
    togglePanel(e) {
        const $wrapper = $(e.currentTarget).closest(this.wrapperSelector);
        $wrapper.find(this.panelSelector).slideToggle(200);
    }

    // Submit button dispatcher
    submitDispatcher(e) {
        const $wrapper = $(e.currentTarget).closest(this.wrapperSelector);
        const message = $.trim($wrapper.find(this.textSelector).val());

        if (!message) {
            this.tip.createTip('error', 'لطفا متن خود را وارد کنید.');
            return;
        }

        this.sendRequest($wrapper, message);
    }

    // Send request to AI
    async sendRequest($wrapper, message) {
        const objectId = $wrapper.attr('data-object-id');
        if (!objectId) {
            console.error('No object ID found');
            return;
        }

        const $preloader = $wrapper.find(this.preloaderSelector);
        const $response = $wrapper.find(this.responseSelector);
        const $submit = $wrapper.find(this.submitSelector);

        // Show preloader, hide response
        $response.hide().empty();
        $preloader.show();
        $submit.prop('disabled', true);

        try {
            const response = await this.makeRequest({
                method: 'POST',
                data: {
                    object_id: objectId,
                    message: message,
                },
            });

            if (response && response.answer) {
                this.displayAnswer($response, response.answer);
                console.log(
                    `AI response received for object ${objectId}:`,
                    response,
                );
            } else {
                this.displayError($response);
            }
        } catch (error) {
            console.error('Error sending AI request:', error);
            this.displayError($response);

            if (error.status === 400) {
                this.tip.createTip(
                    'error',
                    'درخواست نامعتبر است. لطفا دوباره تلاش کنید.',
                );
            } else if (error.status === 500) {
                this.tip.createTip(
                    'error',
                    'خطا در ارتباط با سرور هوش مصنوعی.',
                );
            }
        } finally {
            $preloader.hide();
            $submit.prop('disabled', false);
        }
    }

    // Display answer in response box
    displayAnswer($response, answer) {
        $response
            .html(
                '<div class="irantheme-ai-request-response-inner">' +
                    $('<div>').text(answer).html() +
                    '</div>',
            )
            .show();
    }

    // Display error in response box
    displayError($response) {
        $response
            .html(
                '<div class="irantheme-ai-request-response-error">' +
                    'خطا در ارتباط با سرور هوش مصنوعی، لطفا دوباره تلاش کنید.' +
                    '</div>',
            )
            .show();
    }

    // Generic AJAX request handler
    makeRequest({ method, data }) {
        const url = `${iranthemeWpData.restUrl}irantheme/v1/manageAiRequest`;

        return $.ajax({
            url: url,
            type: method,
            data: data,
            beforeSend: (xhr) => {
                xhr.setRequestHeader('X-WP-Nonce', iranthemeWpData.nonce);
            },
        });
    }
}

export default AiRequest;
